﻿import * as React from 'react';

import '../styles.scss';

import { TextContent } from '../Text/TextContent';

type Props = {
    datasourceId: string;
    onClick: () => void;
    style: any;
    idButton: string;
    textContent?: TextContent;
};

export const ConnectButton: React.FC<Props> = (props): React.ReactElement => {
    return (
        <div className={'finagraph-strongbox-accounting-pkg-connect-container'}>
            <button
                className={`finagraph-strongbox-accounting-pkg-connect-button`}
                onClick={props.onClick}
                style={props.style}
                id={props.idButton}
                tabIndex={1}
            >
                {props.textContent?.TextValue('Connect') || 'Connect'}
            </button>
        </div>
    );
}
